import { render, staticRenderFns } from "./updateMobile.vue?vue&type=template&id=2b17e656&scoped=true"
import script from "./updateMobile.vue?vue&type=script&lang=js"
export * from "./updateMobile.vue?vue&type=script&lang=js"
import style0 from "./updateMobile.vue?vue&type=style&index=0&id=2b17e656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b17e656",
  null
  
)

export default component.exports